module.exports = __webpack_public_path__ + "img/new-doc-icon.ea7ee2af.svg";